'use client'

import { MultiChoiceSentenceQuestion } from '@entities/lesson'
import React from 'react'

import { HStack, Typography } from '@podo-app/design-system-temp'

type Props = {
  question: MultiChoiceSentenceQuestion
}

export const EnglishMultiChoiceSentenceHintFunnel = ({ question }: Props) => {
  return (
    <React.Fragment>
      {question.source.hint.map((hint) => (
        <HStack key={hint.vocab} className="gap-2">
          <Typography size="h2" className="text-[#819DFF]">
            {hint.vocab}
          </Typography>
          <Typography size="body1" className="text-gray-500 font-medium">
            {hint.vocab_translation}
          </Typography>
        </HStack>
      ))}
    </React.Fragment>
  )
}

export const JapaneseMultiChoiceSentenceHintFunnel = ({ question }: Props) => {
  return (
    <React.Fragment>
      {question.source.hint.map((hint) => (
        <HStack key={hint.vocab} className="gap-2">
          <Typography size="h2" className="text-[#819DFF] font-noto-jp">
            {hint.vocab}
          </Typography>
          <Typography size="body1" className="text-gray-500 font-medium">
            {hint.vocab_translation}
          </Typography>
        </HStack>
      ))}
    </React.Fragment>
  )
}
